// @workflow assistant.approvals
/**
 * What a confirmed write changed (AVA-755): a write's `tool.end` carries `changed: [{ kind, id, boardId? }]`,
 * named by the server from what the API saved (contract: .claude/features/AVA_ASSISTANT_EVENT_CONTRACT.md,
 * "Events" › `tool.end`). The assistant's one receiver (services/changeAnnouncer.js) reads it here and announces
 * it to the app, so an open screen refreshes what AVA changed.
 *
 * No imports, so `npm run test:unit` (node --test) can load it directly.
 */

/** The kinds an open screen refreshes today. Another kind is valid and does nothing (`kind` is open). */
export const CHANGED_KIND = Object.freeze({ TASK: 'task' });

/** The contract's cap (schema `toolEnd.changed.maxItems`; aiva.api McpReplyChanges.MaxRecords). */
export const MAX_CHANGED_RECORDS = 20;

const TOOL_END = 'tool.end';

const text = (value) => (typeof value === 'string' && value.length > 0 ? value : null);
const id = (value) => (Number.isFinite(value) ? String(value) : text(value));

/**
 * @param {object} event an assistant event, live from the stream
 * @returns {Array<{ id: string, boardId: string|null }>} the tasks a write's tool.end changed; [] for anything else
 */
export function changedTasksOf(event) {
  if (!event || event.type !== TOOL_END || !Array.isArray(event.changed)) return [];
  return event.changed
    .slice(0, MAX_CHANGED_RECORDS)
    .filter((record) => record && record.kind === CHANGED_KIND.TASK && id(record.id))
    .map((record) => ({ id: id(record.id), boardId: text(record.boardId) }));
}
